export default "__VITE_ASSET__30b21a89__"